import highchartsMore from 'highcharts/highcharts-more';
import Highcharts from 'highcharts/highstock';
import DarkUnica from 'highcharts/themes/dark-unica';

// HighchartMore is needed to have area range and lines
highchartsMore(Highcharts);

// Change highchart theme
DarkUnica(Highcharts);
